import { createContext, useContext } from "react";
import { useRouteLoaderData } from "react-router";
import type { Design } from "~/cookies";

// The root App pins the first design it loads for the life of the document, so a later loader run never swaps the look mid-visit.
export const DesignContext = createContext<Design | null>(null);

// The visit's design direction: the pinned one, else the root loader's (error pages render outside the App).
export default function useDesign(): Design {
  const pinned = useContext(DesignContext);
  const data = useRouteLoaderData("root") as { design?: Design } | undefined;
  return pinned ?? data?.design ?? "a";
}
